import React from 'react';
import SectionTag from '../common/SectionTag';
import { useTranslation } from '../../i18n';

const Structure = () => {
  const { t } = useTranslation();

  const organs = [
    { icon: '🏛', titleKey: 'org_ag_title', descKey: 'org_ag_desc' },
    { icon: '⚙️', titleKey: 'org_be_title', descKey: 'org_be_desc' },
    { icon: '🔬', titleKey: 'org_cs_title', descKey: 'org_cs_desc' },
    { icon: '📊', titleKey: 'org_cc_title', descKey: 'org_cc_desc' },
  ];

  const bureauMembers = [
    'bureau_president',
    'bureau_vp',
    'bureau_sg',
    'bureau_sga',
    'bureau_rp',
    'bureau_rpa',
    'bureau_finance',
    'bureau_financea',
    'bureau_com',
    'bureau_coma',
    'bureau_mob',
    'bureau_moba',
    'bureau_women',
    'bureau_diaspora',
    'bureau_youth',
    'bureau_logistics',
    'bureau_projects',
    'bureau_advisors',
  ];

  return (
    <section className="px-4 md:px-10 py-20" id="structure">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        {/* Left column */}
        <div>
          <SectionTag>{t('structure_tag')}</SectionTag>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-2">
            {t('structure_title')}
          </h2>
          <p className="text-ofd-gray mb-2">{t('structure_desc')}</p>

          <ul className="list-none mt-7">
            {organs.map((org, index) => (
              <li
                key={index}
                className="flex items-start gap-3.5 py-4 border-b border-ofd-gray-light last:border-b-0"
              >
                <div className="w-10 h-10 flex-shrink-0 bg-ofd-blue rounded-full flex items-center justify-center text-white text-lg">
                  {org.icon}
                </div>
                <div>
                  <strong className="block text-sm font-semibold">{t(org.titleKey)}</strong>
                  <span className="text-ofd-gray text-sm">{t(org.descKey)}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Right column */}
        <div>
          <SectionTag className="mt-0">{t('bureau_tag')}</SectionTag>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold">{t('bureau_title')}</h2>

          <div className="grid grid-cols-2 gap-3.5 mt-5">
            {bureauMembers.map((key) => (
              <div
                key={key}
                className="px-4 py-3 bg-ofd-gray-light rounded text-sm font-medium text-ofd-slate border-l-4 border-ofd-blue"
              >
                {t(key)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Structure;